module.exports = __webpack_public_path__ + "img/grafica8.f8757c46.jpg";